import { useQuery, useMutation } from '@tanstack/react-query'
import { categoriesApi } from '../services/categories.service'
import { queryClient } from '@/lib/api/queryClient'
import { qk } from '@/lib/api/queryKeys'
import type { ApiCategory, CreateCategoryInput, UpdateCategoryInput } from '../model/types'

export function useCategories() {
  const q = useQuery({
    queryKey: qk.categories.list,
    queryFn: () => categoriesApi.list(),
    staleTime: 5 * 60_000,
  })
  const data: ApiCategory[] = q.data ?? []
  return { ...q, data }
}

export function useCreateCategory() {
  return useMutation({
    mutationFn: (input: CreateCategoryInput) => categoriesApi.create(input),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: qk.categories.list }) },
  })
}

export function useUpdateCategory() {
  return useMutation({
    mutationFn: (vars: { id: string; input: UpdateCategoryInput }) => categoriesApi.update(vars.id, vars.input),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: qk.categories.list }) },
  })
}

export function useDeleteCategory() {
  return useMutation({
    mutationFn: (id: string) => categoriesApi.remove(id),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: qk.categories.list }) },
  })
}
